import React, { useState, useEffect } from 'react'
import '../styles/home.css'
import { LazyLoadImage } from "react-lazy-load-image-component";
import { Carousel } from 'react-responsive-carousel';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import Packages from './packages'
import About from './about'
import Contact from './contact'
import decoration from '../images/decoration.svg';
import getFrontCarouselSlides from '../utils/frontCarouselImages';
import img1_copy from '../images/gallery/DSC_1680 copy.webp';
import img1 from '../images/gallery/DSC05728.webp';
import img2_copy from '../images/gallery/DSC08773.webp';
import img2 from '../images/gallery/DSC_2007 copy.webp';
import { useScrollAnimation } from '../utils/useScrollAnimation';
import { useParallax } from '../utils/scrollAnimations';

import { MasonryPhotoAlbum } from "react-photo-album";
import "react-photo-album/masonry.css";
import { Link, useLocation } from "react-router-dom";

function Home() {
  const location = useLocation();
  const [isMobile, setIsMobile] = useState(window.innerWidth < 1024);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 1024);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Handle hash-based scrolling when coming from other pages
  useEffect(() => {
    if (location.hash) {
      const element = document.querySelector(location.hash);
      if (element) {
        setTimeout(() => {
          element.scrollIntoView({ behavior: 'smooth' });
        }, 0);
      }
    }
  }, [location]);

  const heroSlides = getFrontCarouselSlides();
  
  // Scroll animation refs for different sections
  const taglineRef = useScrollAnimation();
  const galleryRef = useScrollAnimation();
  const packagesRef = useScrollAnimation();
  const aboutRef = useScrollAnimation();
  const contactRef = useScrollAnimation();

  // Parallax effect for hero - subtle movement on scroll (disable on mobile)
  const heroParallaxRef = useParallax({
    speed: isMobile ? 0 : 0.25,
    direction: 'up'
  });

  // Preview gallery - 4 portrait images only
  const allPhotoes = [
    { src: img1_copy, width: 200, height: 300 },
    { src: img1, width: 200, height: 300 },
    { src: img2_copy, width: 200, height: 300 },
    { src: img2, width: 200, height: 300 }
  ];

  // Show 3 images on mobile, 4 on desktop for preview
  const photoes = isMobile ? allPhotoes.slice(0, 3) : allPhotoes;
  
  return (
    <>
      <section id="home" className="hero-section" aria-label="Welcome">
        <div className="hero-visual">
          <div className="hero-carousel-layer" ref={heroParallaxRef} aria-hidden="true">
            <Carousel
              className="hero-carousel"
              showArrows
              showIndicators
              showStatus={false}
              showThumbs={false}
              infiniteLoop
              autoPlay
              interval={5500}
              transitionTime={900}
              stopOnHover
              swipeable
              emulateTouch
              useKeyboardArrows
              dynamicHeight
            >
              {heroSlides.map((slide, i) => (
                <div className="hero-slide" key={slide.src + String(i)}>
                  <img src={slide.src} alt={slide.alt} loading={i === 0 ? 'eager' : 'lazy'} />
                </div>
              ))}
            </Carousel>
          </div>
        </div>
      </section>

      <section className="tagline-strip scroll-animate" ref={taglineRef} aria-label="Our tagline">
        <div className="tagline-inner">
          <div className="tagline-dec" aria-hidden="true">
            <LazyLoadImage src={decoration} alt="" />
          </div>
          <p className="tagline-text">Trying to capture your subtle moments</p>
          <div className="tagline-dec" aria-hidden="true">
            <LazyLoadImage src={decoration} alt="" />
          </div>
        </div>
      </section>

      <section id="sc-gallery" className="home-gallery-preview scroll-animate" ref={galleryRef} aria-labelledby="gallery-preview-title">
          <p className="section-eyebrow" id="gallery-preview-title">Portfolio</p>
          <h2 className="section-title">Gallery</h2>
          <div className="section-line" aria-hidden="true" />
          <div className="home-gallery-inner">
            <MasonryPhotoAlbum photos={photoes} columns={(containerWidth) => {
              if (containerWidth < 768) return 3;
              return 4;
            }} />
          </div>
          <div className="home-gallery-cta">
            <Link to="/gallery" className="btn btn-primary">Show More</Link>
          </div>
      </section>

      <section id='packages' ref={packagesRef} className="scroll-animate">
        <Packages />
      </section>
      <section id='about' ref={aboutRef} className="scroll-animate">
        <About />
      </section>
      <section id='contact' ref={contactRef} className="scroll-animate">
        <Contact />
      </section>
    </>
  )
}

export default Home
